document.addEventListener('DOMContentLoaded', () => {
    
    // 1. Navbar Scroll Effect
    const navbar = document.querySelector('.navbar');
    if (navbar) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }
        });
    }

    // 2. Cart Drawer Logic
    const cartToggles = document.querySelectorAll('.cart-toggle');
    const cartClose = document.querySelector('.cart-close');
    const cartDrawer = document.querySelector('.cart-drawer');
    const cartOverlay = document.querySelector('.cart-overlay');

    const openCart = (e) => {
        if(e) e.preventDefault();
        if(cartDrawer) cartDrawer.classList.add('is-active');
        if(cartOverlay) cartOverlay.classList.add('is-active');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
    };

    const closeCart = () => {
        if(cartDrawer) cartDrawer.classList.remove('is-active');
        if(cartOverlay) cartOverlay.classList.remove('is-active');
        document.body.style.overflow = '';
    };

    if (cartToggles) {
        cartToggles.forEach(toggle => toggle.addEventListener('click', openCart));
    }
    if (cartClose) {
        cartClose.addEventListener('click', closeCart);
    }
    if (cartOverlay) {
        cartOverlay.addEventListener('click', closeCart);
    }

    // 3. Scroll Reveal Animations (Intersection Observer)
    const revealElements = document.querySelectorAll('.reveal');
    const revealOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px"
    };

    const revealOnScroll = new IntersectionObserver(function(entries, observer) {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                return;
            } else {
                entry.target.classList.add('active');
                observer.unobserve(entry.target);
            }
        });
    }, revealOptions);

    revealElements.forEach(el => {
        revealOnScroll.observe(el);
    });

    // 4. Hero Background Load Animation
    const hero = document.querySelector('.hero');
    if (hero) {
        // Simple timeout to add the loaded class, giving the CSS transition time to kick in
        setTimeout(() => {
            hero.classList.add('is-loaded');
        }, 100);
    }

    // 5. Accordion Logic (for PDP)
    const accordions = document.querySelectorAll('.accordion-header');
    accordions.forEach(acc => {
        acc.addEventListener('click', function() {
            this.classList.toggle('active');
            const panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    });

    // 6. Variant Selector Logic (for PDP Shopify)
    const variantSelectors = document.querySelectorAll('.variant-selector');
    const variantIdInput = document.getElementById('product-variant-id');
    const variantsJsonEl = document.getElementById('product-variants-json');
    const addToCartForm = document.getElementById('add-to-cart-form');
    const addToCartButton = addToCartForm ? addToCartForm.querySelector('button[type="submit"]') : null;

    let productVariants = [];
    if (variantsJsonEl) {
        try {
            productVariants = JSON.parse(variantsJsonEl.textContent);
        } catch (e) {
            console.error('Error parsing variants JSON', e);
        }
    }

    function updatePills() {
        if (!variantSelectors || variantSelectors.length === 0 || productVariants.length === 0) return;
        const currentSelectedOptions = [];
        variantSelectors.forEach(sel => {
            const activePill = sel.querySelector('.pill.active');
            currentSelectedOptions.push(activePill ? activePill.getAttribute('data-value') : null);
        });

        variantSelectors.forEach((selector, index) => {
            const pills = selector.querySelectorAll('.pill');
            pills.forEach(pill => {
                const val = pill.getAttribute('data-value');
                const testOptions = [...currentSelectedOptions];
                testOptions[index] = val; 

                const variantExists = productVariants.find(variant => {
                    return testOptions.every((testVal, i) => {
                        if (testVal === null) return true;
                        return variant.options[i] === testVal;
                    });
                });

                if (!variantExists || (variantExists && !variantExists.available)) {
                    pill.classList.add('sold-out');
                } else {
                    pill.classList.remove('sold-out');
                }
            });
        });
    }

    if (variantSelectors.length > 0 && productVariants.length > 0) {
        updatePills();

        variantSelectors.forEach(selector => {
            const pills = selector.querySelectorAll('.pill');
            pills.forEach(pill => {
                pill.addEventListener('click', function() {
                    if (this.classList.contains('sold-out')) return;

                    pills.forEach(p => p.classList.remove('active'));
                    this.classList.add('active');

                    updatePills();

                    const selectedOptions = [];
                    variantSelectors.forEach(sel => {
                        const activePill = sel.querySelector('.pill.active');
                        if (activePill) {
                            selectedOptions.push(activePill.getAttribute('data-value'));
                        }
                    });

                    const matchedVariant = productVariants.find(variant => {
                        return selectedOptions.every((val, index) => variant.options[index] === val);
                    });

                    if (matchedVariant) {
                        if (variantIdInput) variantIdInput.value = matchedVariant.id;
                        
                        if (addToCartButton) {
                            if (matchedVariant.available) {
                                addToCartButton.disabled = false;
                                addToCartButton.textContent = 'Adicionar ao Carrinho';
                            } else {
                                addToCartButton.disabled = true;
                                addToCartButton.textContent = 'Esgotado';
                            }
                        }
                    } else {
                        if (addToCartButton) {
                            addToCartButton.disabled = true;
                            addToCartButton.textContent = 'Indisponível';
                        }
                    }
                });
            });
        });
    }

    // Handle AJAX Add to Cart
    if (addToCartForm) {
        addToCartForm.addEventListener('submit', function(e) {
            e.preventDefault();
            const submitBtn = this.querySelector('button[type="submit"]');
            const originalText = submitBtn.textContent;
            submitBtn.textContent = 'Adicionando...';
            submitBtn.disabled = true;

            const formData = new FormData(addToCartForm);

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => {
                if (!response.ok) throw new Error('Error adding to cart');
                return response.json();
            })
            .then(() => {
                // Fetch updated cart drawer
                return fetch(window.Shopify.routes.root + '?section_id=cart-drawer');
            })
            .then(response => response.text())
            .then(text => {
                const html = new DOMParser().parseFromString(text, 'text/html');
                const newDrawer = html.querySelector('.cart-drawer');
                if (newDrawer) {
                    const currentDrawer = document.querySelector('.cart-drawer');
                    if (currentDrawer) {
                        currentDrawer.innerHTML = newDrawer.innerHTML;
                        const newCartClose = currentDrawer.querySelector('.cart-close');
                        if (newCartClose) {
                            newCartClose.addEventListener('click', closeCart);
                        }
                    }
                }
                openCart();
            })
            .catch(error => {
                console.error(error);
                alert('Erro ao adicionar produto. Tente novamente.');
            })
            .finally(() => {
                submitBtn.disabled = false;
                submitBtn.textContent = originalText;
            });
        });
    }

    // Event delegation for cart remove
    document.addEventListener('click', function(e) {
        if (e.target.matches('.cart-item-remove')) {
            e.preventDefault();
            e.target.textContent = 'Removendo...';
            
            fetch(e.target.href)
            .then(() => fetch(window.Shopify.routes.root + '?section_id=cart-drawer'))
            .then(response => response.text())
            .then(text => {
                const html = new DOMParser().parseFromString(text, 'text/html');
                const newDrawer = html.querySelector('.cart-drawer');
                if (newDrawer) {
                    const currentDrawer = document.querySelector('.cart-drawer');
                    if (currentDrawer) {
                        currentDrawer.innerHTML = newDrawer.innerHTML;
                        const newCartClose = currentDrawer.querySelector('.cart-close');
                        if (newCartClose) {
                            newCartClose.addEventListener('click', closeCart);
                        }
                    }
                }
            })
            .catch(err => console.error(err));
        }
    });

    // 7. Hero Slideshow Logic
    const heroSlides = document.querySelectorAll('.hero-slide');
    if (heroSlides.length > 1) {
        let currentSlide = 0;
        setInterval(() => {
            heroSlides[currentSlide].classList.remove('active');
            currentSlide = (currentSlide + 1) % heroSlides.length;
            heroSlides[currentSlide].classList.add('active');
        }, 5000); // Transition every 5 seconds
    }

    // 8. Mobile Menu Logic
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const navLinks = document.querySelector('.nav-links');
    if (mobileMenuToggle && navLinks) {
        mobileMenuToggle.addEventListener('click', () => {
            navLinks.classList.toggle('is-active');
            // Change icon
            if (navLinks.classList.contains('is-active')) {
                mobileMenuToggle.innerHTML = '✕';
            } else {
                mobileMenuToggle.innerHTML = '☰';
            }
        });
    }

    // 7. Zoom Logic for PDP Gallery
    const zoomModal = document.getElementById('zoomModal');
    const zoomImg = document.getElementById('zoomImg');
    const zoomClose = document.getElementById('zoomClose');
    const galleryImages = document.querySelectorAll('.pdp-gallery img');

    if (zoomModal && zoomImg && zoomClose && galleryImages.length > 0) {
        galleryImages.forEach(img => {
            img.addEventListener('click', function() {
                zoomModal.classList.add('active');
                zoomImg.src = this.src;
                document.body.style.overflow = 'hidden';
            });
        });

        zoomClose.addEventListener('click', function() {
            zoomModal.classList.remove('active');
            document.body.style.overflow = '';
        });

        zoomModal.addEventListener('click', function(e) {
            if (e.target !== zoomImg) {
                zoomModal.classList.remove('active');
                document.body.style.overflow = '';
            }
        });
    }

    // 8. Card Cart Button — Add to Cart via AJAX (for simple products)
    document.addEventListener('click', function(e) {
        // Handle direct add to cart
        const btn = e.target.closest('.card-cart-btn[data-variant-id]');
        if (btn && !btn.classList.contains('quick-add-btn')) {
            e.preventDefault();
            const variantId = btn.dataset.variantId;
            if (!variantId) return;

            btn.disabled = true;
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: 1 })
            })
            .then(r => {
                if (!r.ok) throw new Error('Error adding to cart');
                return r.json();
            })
            .then(() => {
                // Visual feedback
                btn.classList.add('added');
                const originalHTML = btn.innerHTML;
                btn.innerHTML = '✓';
                setTimeout(() => {
                    btn.classList.remove('added');
                    btn.innerHTML = originalHTML;
                    btn.disabled = false;
                }, 1500);

                openCartDrawerAndUpdate();
            })
            .catch(() => {
                btn.disabled = false;
                alert('Ocorreu um erro ao adicionar ao carrinho. Tente novamente.');
            });
        }

        // Handle Quick Add Modal trigger
        const quickAddBtn = e.target.closest('.quick-add-btn');
        if (quickAddBtn) {
            e.preventDefault();
            const handle = quickAddBtn.dataset.productHandle;
            if (!handle) return;
            
            quickAddBtn.disabled = true;
            fetch(`/products/${handle}.js`)
            .then(r => r.json())
            .then(product => {
                quickAddBtn.disabled = false;
                openQuickAddModal(product);
            })
            .catch(() => {
                quickAddBtn.disabled = false;
            });
        }
    });

    // Quick Add Modal Logic
    const qaModal = document.querySelector('.quick-add-modal');
    const qaOverlay = document.querySelector('.quick-add-overlay');
    const qaClose = document.querySelector('.quick-add-close');
    const qaSelectorsContainer = document.getElementById('quick-add-selectors');
    const qaTitle = document.getElementById('quick-add-title');
    const qaSubmit = document.getElementById('quick-add-submit');
    let selectedVariantId = null;
    let currentProduct = null;

    function openQuickAddModal(product) {
        if (!qaModal || !qaOverlay || !qaSelectorsContainer) return;
        
        currentProduct = product;
        if (qaTitle) qaTitle.textContent = product.title;
        qaSelectorsContainer.innerHTML = '';
        selectedVariantId = null;
        qaSubmit.disabled = true;
        
        product.options.forEach((option, index) => {
            // Shopify limits to 3 options: option1, option2, option3
            const wrapper = document.createElement('div');
            wrapper.style.marginBottom = '10px';
            
            const label = document.createElement('label');
            label.textContent = option.name;
            label.style.display = 'block';
            label.style.marginBottom = '5px';
            label.style.color = '#fff';
            label.style.fontSize = '0.9rem';
            
            const select = document.createElement('select');
            select.className = 'quick-add-select';
            select.dataset.optionIndex = `option${index + 1}`;
            
            const defaultOpt = document.createElement('option');
            defaultOpt.value = '';
            defaultOpt.textContent = `Selecione ${option.name}`;
            defaultOpt.disabled = true;
            defaultOpt.selected = true;
            select.appendChild(defaultOpt);
            
            option.values.forEach(val => {
                const opt = document.createElement('option');
                opt.value = val;
                opt.textContent = val;
                select.appendChild(opt);
            });
            
            select.addEventListener('change', checkVariantAvailability);
            
            wrapper.appendChild(label);
            wrapper.appendChild(select);
            qaSelectorsContainer.appendChild(wrapper);
        });
        
        qaModal.classList.add('active');
        qaOverlay.classList.add('active');
    }

    function checkVariantAvailability() {
        if (!currentProduct) return;
        
        const selects = document.querySelectorAll('.quick-add-select');
        let selectedOptions = {};
        let allSelected = true;
        
        selects.forEach(sel => {
            if (!sel.value) allSelected = false;
            selectedOptions[sel.dataset.optionIndex] = sel.value;
        });
        
        if (!allSelected) {
            qaSubmit.disabled = true;
            selectedVariantId = null;
            return;
        }
        
        // Find matching variant
        const matchedVariant = currentProduct.variants.find(v => {
            return (selectedOptions.option1 ? v.option1 === selectedOptions.option1 : true) &&
                   (selectedOptions.option2 ? v.option2 === selectedOptions.option2 : true) &&
                   (selectedOptions.option3 ? v.option3 === selectedOptions.option3 : true);
        });
        
        if (matchedVariant && matchedVariant.available) {
            selectedVariantId = matchedVariant.id;
            qaSubmit.disabled = false;
            qaSubmit.textContent = 'ADICIONAR AO CARRINHO';
        } else {
            selectedVariantId = null;
            qaSubmit.disabled = true;
            qaSubmit.textContent = 'ESGOTADO';
        }
    }
    
    function closeQuickAddModal() {
        if (qaModal) qaModal.classList.remove('active');
        if (qaOverlay) qaOverlay.classList.remove('active');
    }
    
    if (qaClose) qaClose.addEventListener('click', closeQuickAddModal);
    if (qaOverlay) qaOverlay.addEventListener('click', closeQuickAddModal);
    
    if (qaSubmit) {
        qaSubmit.addEventListener('click', () => {
            if (!selectedVariantId) return;
            qaSubmit.disabled = true;
            qaSubmit.textContent = 'ADICIONANDO...';
            
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
            })
            .then(r => {
                if (!r.ok) throw new Error('Error');
                return r.json();
            })
            .then(() => {
                closeQuickAddModal();
                qaSubmit.disabled = false;
                qaSubmit.textContent = 'ADICIONAR AO CARRINHO';
                openCartDrawerAndUpdate();
            })
            .catch(() => {
                qaSubmit.disabled = false;
                qaSubmit.textContent = 'ADICIONAR AO CARRINHO';
                alert('Erro ao adicionar. Tente novamente.');
            });
        });
    }

    function openCartDrawerAndUpdate() {
        fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
            const countEls = document.querySelectorAll('#cart-count, #cart-count-drawer');
            countEls.forEach(el => el.textContent = cart.item_count);

            const drawer = document.querySelector('.cart-drawer');
            const overlay = document.querySelector('.cart-overlay');
            if (drawer) drawer.classList.add('is-active');
            if (overlay) overlay.classList.add('is-active');
            document.body.style.overflow = 'hidden';

            fetch('/?section_id=cart-drawer')
                .then(r => r.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newDrawer = doc.querySelector('.cart-drawer');
                    if (drawer && newDrawer) {
                        drawer.innerHTML = newDrawer.innerHTML;
                    }
                });
        });
    }

    // Hero Carousel Logic
    const heroCarousel = document.getElementById('heroCarousel');
    if (heroCarousel) {
        const slides = heroCarousel.querySelectorAll('.hero-slide');
        const dots = heroCarousel.querySelectorAll('.hero-carousel-dot');
        let currentSlide = 0;
        let slideInterval;

        function goToSlide(index) {
            slides[currentSlide].classList.remove('active');
            dots[currentSlide].classList.remove('active');
            currentSlide = index;
            slides[currentSlide].classList.add('active');
            dots[currentSlide].classList.add('active');
        }

        function nextSlide() {
            let next = (currentSlide + 1) % slides.length;
            goToSlide(next);
        }

        function startSlide() {
            slideInterval = setInterval(nextSlide, 6000);
        }

        function stopSlide() {
            clearInterval(slideInterval);
        }

        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                stopSlide();
                goToSlide(index);
                startSlide();
            });
        });

        startSlide();
    }
});
